(function() {
  var ContactsHandler,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ContactsHandler = App.loadClass("grower::handlers/contacts/Contacts_Handler");

  exports.Confirm_Tab_Handler = (function(superClass) {
    extend(Confirm_Tab_Handler, superClass);

    function Confirm_Tab_Handler() {
      return Confirm_Tab_Handler.__super__.constructor.apply(this, arguments);
    }

    Confirm_Tab_Handler.prototype.init = function() {
      var msgwriter;
      this.layoutUrl = "backend/grower/contacts/confirmtab/load-layout";
      this.layoutSelector = "#contactstab_confirm";
      msgwriter = App.sidebar.messageWriter();
      msgwriter.message_writer();
      msgwriter.message_writer('info', 'Loading...');
      return this.loadLayout();
    };

    Confirm_Tab_Handler.prototype.afterLoadLayout = function(selector, data) {
      var ths;
      ths = this;
      $(this.layoutSelector).find('.sel-permission').change({
        'ths': ths
      }, ths.permissionListener);
      $(this.layoutSelector).find('.ignore-btn').click(function(e) {
        var btn;
        btn = $(this);
        return $.post('backend/grower/contacts/confirmtab/ignorecontact-ajax', {
          'contact_id': btn.data('contact_id')
        }, function(json) {
          if (json.status.type === 'success') {
            return btn.parents('tr').empty().append("<td class='removal_success'>Request Ignored</td> <td></td> <td></td>");
          } else {
            return App.current_page.refreshSubHandlers();
          }
        });
      });
      $(this.layoutSelector).find('.block-btn').click(function(e) {
        var btn;
        btn = $(this);
        return $.post('backend/grower/contacts/confirmtab/blockcontact-ajax', {
          'contact_id': btn.data('contact_id')
        }, function(json) {
          if (json.status.type === 'success') {
            return btn.parents('tr').empty().append("<td class='removal_success'>User Blocked</td> <td></td> <td></td>");
          } else {
            return App.current_page.refreshSubHandlers();
          }
        });
      });
      return this.tabLoadLayoutCallback(selector, data);
    };

    Confirm_Tab_Handler.prototype.permissionListener = function(event) {
      var contact_id, contact_name, original, permission_id, sel, ths, tr;
      ths = event.data.ths;
      sel = $(this);
      tr = sel.parents('tr');
      original = tr.html();
      contact_id = sel.data('contact_id');
      contact_name = sel.data('contact_name');
      permission_id = sel.val();
      sel.replaceWith('<text class="saving">Saving...</text>');
      return $.post('backend/grower/contacts/confirmtab/confirmcontact-ajax', {
        'contact_id': contact_id,
        'permission_id': permission_id
      }, function(json) {
        var confirmed, undo;
        if (json.status.type === 'success') {
          confirmed = "<text class='contact_success'>Contact Confirmed!</text>";
          undo = "<a class='a-undo' data-contact_id=" + contact_id + " data-permission_id=" + permission_id + ">(Undo)</a>";
          tr.empty().append("<td colspan='3'> " + confirmed + " &nbsp;&nbsp;&nbsp;&nbsp; " + undo + " </td>");
          return tr.find('.a-undo').bind("click", {
            'tr': tr,
            'original': original,
            'ths': ths
          }, ths.undoListener);
        } else {
          return App.current_page.refreshSubHandlers();
        }
      });
    };

    Confirm_Tab_Handler.prototype.undoListener = function(event) {
      var a, contact_id, original, permission_id, ths, tr;
      ths = event.data.ths;
      tr = event.data.tr;
      original = event.data.original;
      event.preventDefault();
      a = $(this);
      contact_id = a.data('contact_id');
      permission_id = a.data('permission_id');
      return $.post('backend/grower/contacts/confirmtab/undoconfirm-ajax', {
        'contact_id': contact_id,
        'permission_id': permission_id
      }, function(json) {
        if (json.status.type === 'success') {
          tr.empty().append(original);
          return tr.find('.sel-permission').bind("change", {
            'ths': ths
          }, ths.permissionListener);
        } else {
          return App.current_page.refreshSubHandlers();
        }
      });
    };

    return Confirm_Tab_Handler;

  })(ContactsHandler);

}).call(this);
